/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserLeaderboardRankResponse
 */
export interface UserLeaderboardRankResponse {
    /**
     * 
     * @type {number}
     * @memberof UserLeaderboardRankResponse
     */
    rank: number;
}

/**
 * Check if a given object implements the UserLeaderboardRankResponse interface.
 */
export function instanceOfUserLeaderboardRankResponse(value: object): value is UserLeaderboardRankResponse {
    if (!('rank' in value) || value['rank'] === undefined) return false;
    return true;
}

export function UserLeaderboardRankResponseFromJSON(json: any): UserLeaderboardRankResponse {
    return UserLeaderboardRankResponseFromJSONTyped(json, false);
}

export function UserLeaderboardRankResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLeaderboardRankResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rank': json['rank'],
    };
}

export function UserLeaderboardRankResponseToJSON(json: any): UserLeaderboardRankResponse {
    return UserLeaderboardRankResponseToJSONTyped(json, false);
}

export function UserLeaderboardRankResponseToJSONTyped(value?: UserLeaderboardRankResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rank': value['rank'],
    };
}

